// 获取今天和昨天的时间
export const getTodayTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    // console.log(year,month,day);
    let time = {
        today : correction(year) + '-' + correction(month) + '-' + correction(day),
        yesterday : correction(year) + '-' + correction(month) + '-' + correction(day - 1)
    }
    return time
}

// 一位数前补0
const correction = (time)=>{
    return time>=0 && time<10 ? '0'+time :time
}

// 获取当前月的时间
export const getMonthTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    let time = {
        end : correction(year) + '-' + correction(month) + '-' + correction(day),
        start : correction(year) + '-' + correction(month) + '-1'
    }
    return time
}

// 获取今天和昨天的时间
export const getTodayYesTime =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()
    // console.log(year,month,day);
    let time = {
        today : correction(year) + '-' + correction(month) + '-' + correction(day),
        yesterday : correction(year) + '-' + correction(month) + '-' + correction(day - 1)
    }
    return time
}

// 获取最近7天的时间 ,数据要的急，暂时不考虑月头跨月的情况
export const getSevenDays =()=>{
    let currentime = new Date()
    let year = currentime.getFullYear()
    let month = currentime.getMonth() + 1
    let day = currentime.getDate()

    let time = {
        one : correction(year) + '-' + correction(month) + '-' + correction(day),
        two : correction(year) + '-' + correction(month) + '-' + correction(day - 1),
        three : correction(year) + '-' + correction(month) + '-' + correction(day - 2),
        four : correction(year) + '-' + correction(month) + '-' + correction(day - 3),
        five : correction(year) + '-' + correction(month) + '-' + correction(day - 4),
        six : correction(year) + '-' + correction(month) + '-' + correction(day - 5),
        seven : correction(year) + '-' + correction(month) + '-' + correction(day - 6),
    }
    return time
}

// 获取最近7天的时间 
export const getLastOrNextFewDateBy =(value)=> {
    let timeList = []
    let receiver = []
    let timedate = value 
        for (let i = -6; i <= 0; i++) {
            let today = new Date();
            if (timedate) {
            receiver = timedate;
            } else {
            receiver = today;
            }
            let lastOrNextDate = receiver.getTime() + 1000 * 60 * 60 * 24 * i;
            today.setTime(lastOrNextDate);
            // var year = today.getFullYear();
            let month = today.getMonth() + 1;
            if (receiver == timedate) {
            let date = today.getDate();
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "/" + date )
            } else {
            let date = today.getDate() - 1;
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "/" + date)
            }
          
        }
        return timeList
    }